import * as React from "react";
export class Checkbox extends React.Component {
    constructor() {
        super(...arguments);
        this.onChange = (event) => {
            this.props.handler && this.props.handler(event);
        };
    }
    render() {
        const { id, checked, disabled, dataUat } = this.props;
        return (React.createElement("span", { className: "rj-checkbox" },
            React.createElement("input", { type: "checkbox", id: id, className: "rj-checkbox__input", checked: checked, disabled: disabled, onChange: this.onChange, "data-uat": dataUat }),
            React.createElement("label", { htmlFor: id, className: "rj-checkbox__label" }, this.props.children)));
    }
}
//# sourceMappingURL=Checkbox.js.map